import { __assign, __rest } from 'tslib';
import React, { useMemo, useRef, useState } from 'react';
import useMeasure from 'react-use-measure';
import { v4 } from 'uuid';
import { CaretRightIcon } from '@panwds/icons';
import { useSpring, config, a } from '@react-spring/web';
import { classNames } from '../../utils/classNames/classNames.esm.js';
import '@popperjs/core';
import '../Tooltip/Tooltip.esm.js';
import { Title } from '../Typography/Title.esm.js';

/**
 * A collapsible panel
 */
function AccordionPanel(_a) {
    var _b = _a.canClose, canClose = _b === void 0 ? true : _b, children = _a.children, icon = _a.icon, _c = _a.isOpen, isOpen = _c === void 0 ? true : _c, _d = _a.level, level = _d === void 0 ? 4 : _d, _e = _a.noPadding, noPadding = _e === void 0 ? false : _e, _f = _a.indicator, indicator = _f === void 0 ? true : _f, onClick = _a.onClick, title = _a.title, caption = _a.caption, _g = _a.as, Component = _g === void 0 ? "li" : _g, _h = _a.addClassName, addClassName = _h === void 0 ? "" : _h, _j = _a.appearance, appearance = _j === void 0 ? "default" : _j;
    var _k = useMemo(function () {
        var baseId = v4();
        return ["".concat(baseId, "-accordion-button"), "".concat(baseId, "-accordion-body")];
    }, []), buttonId = _k[0], bodyId = _k[1];
    var outerRef = useRef(null);
    var _l = useMeasure(), innerRef = _l[0], bounds = _l[1];
    // const [isAnimatingHeight, setIsAnimatingHeight] = useState<boolean>(false);
    var _m = useState(false), isMounted = _m[0], setIsMounted = _m[1];
    var _o = useSpring({
        immediate: !isMounted,
        config: __assign(__assign({}, config.stiff), { clamp: true }),
        from: {
            height: 0,
            opacity: 0,
            translateY: "-100%"
        },
        to: {
            height: bounds.height,
            opacity: 1,
            translateY: "0%"
        },
        // onRest: {
        //   height:
        //     /* istanbul ignore next - animations are skipped in tests */ () => {
        // setIsAnimatingHeight(false);
        //     },
        // },
        onStart: {
            height: /* istanbul ignore next - animations are skipped in tests */ function () {
                setIsMounted(true);
                // setIsAnimatingHeight(!animation.finished);
            }
        },
        reverse: !isOpen
    }), height = _o.height, style = __rest(_o, ["height"]);
    var iconClasses = classNames("tw-flex tw-flex-initial", caption ? "tw-mt-0.5" : "", !indicator && "tw-ml-2");
    var isCard = appearance === "card";
    var isDefault = appearance === "default";
    return (React.createElement(Component, { "data-testid": "accordion-panel", className: classNames("tw-flex tw-flex-col tw-bg-white dark:tw-bg-gray-1000", isDefault &&
            "tw-border-0 tw-border-b tw-border-solid tw-border-gray-300", isCard && "tw-my-1 tw-border tw-border-solid tw-border-gray-300", addClassName) },
        React.createElement(Title, { addClassName: classNames("tw-w-full tw-bg-white", "dark:tw-bg-gray-1000 dark:tw-border-gray-700", isDefault && "tw-border-none", isCard && "tw-border-gray-100", isOpen &&
                "tw-border tw-border-solid tw-border-gray-800 dark:tw-border-b-1", (canClose || !isOpen) &&
                "hover:tw-bg-blue-200 hover:tw-border-gray-800 dark:hover:tw-bg-gray-800"), level: level, size: "xs" },
            React.createElement("button", { "aria-controls": bodyId, "aria-disabled": isOpen && !canClose, "aria-expanded": isOpen, className: classNames("tw-border-0 tw-bg-transparent tw-font-lato tw-font-semibold tw-flex tw-w-full tw-pl-1 tw-pr-2 tw-py-2 tw-space-x-1 focus-visible:tw-ring", isOpen && !canClose ? "tw-cursor-default" : "tw-cursor-pointer", caption ? "tw-items-start" : "tw-items-center"), id: buttonId, onClick: onClick, type: "button" },
                indicator && (React.createElement("span", { className: "tw-flex tw-flex-initial tw-mx-2" },
                    React.createElement(CaretRightIcon, { "data-testid": "accordion-panel-indicator", className: classNames("tw-text-gray-600 dark:tw-text-dark-bg tw-transition tw-ease-in-out tw-duration-300 tw-origin-center", isOpen ? "tw-rotate-90" : "tw-rotate-0"), size: "xs" }))),
                icon && React.createElement("div", { className: iconClasses }, icon),
                React.createElement("span", { className: classNames("tw-font-lato tw-flex-grow tw-text-left tw-text-base tw-font-semibold tw-text-default dark:tw-text-dark-bg", !indicator && !icon && "tw-ml-2") },
                    title,
                    React.createElement("p", { className: "tw-p-0 tw-m-0 tw-font-normal tw-text-xs tw-text-gray-600 dark:tw-text-dark-bg" }, caption)))),
        React.createElement(a.div, { className: classNames(
            // (isOpen || isAnimatingHeight) && "tw-border",
            "tw-border-t-0 tw-overflow-hidden tw-border-gray-300 tw-will-change-transform", "dark:tw-border-gray-700"), ref: outerRef, style: { height: height } },
            React.createElement(a.div, { "aria-labelledby": buttonId, className: classNames(!noPadding && "tw-p-4", "tw-inset-x-4"), id: bodyId, ref: innerRef, style: style }, children))));
}

export { AccordionPanel };
//# sourceMappingURL=AccordionPanel.esm.js.map
